import React from 'react';
import { Button, Input } from 'antd';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const inputScannerSchema = Yup.object().shape({
  number: Yup.mixed().required('Masukkan nomor personel terlebih dahulu').nullable(true)
});

const InputScanner = ({ onScan }) => {
  return (
    <Formik
      initialValues={{
        number: undefined
      }}
      validationSchema={inputScannerSchema}
      onSubmit={values => {
        onScan(values.number);
      }}
    >
      {(formik) => {
        return (
          <Form>
            <div className="gx-mt-3">
              <Input className="gx-text-center" autoFocus name="number" placeholder="Masukkan nomor personel" value={formik.values.number} onChange={formik.handleChange} size="large" />
              <ErrorMessage name="number" className="gx-text-danger" component="div" />
            </div>

            <div className="gx-mt-3">
              <Button htmlType="submit" type="primary" size="large">Tampilkan Hasil</Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default InputScanner;